export function getNetworkListingDatatableConfig() {
    return {
        dom: 'Bfrtip',
        columns: [
            { 'data': 'name', 'title': 'Name' },
            { 'data': 'ipScopes', 'title': 'Default Gateways' },
            { 'data': 'ipScopes', 'title': 'Prefix Length' },
            { 'data': 'ipScopes', 'title': 'IP Addresses' }
        ],
        columnDefs: [
                {
                    'targets': [1] ,
                    'mRender': function (data, type, row) {
                        let formattedValue = '';
                        if (row.hasOwnProperty('ipScopes')) {
                            row.ipScopes.map(function(item, index) {
                                formattedValue += item.gateway ? item.gateway : '';
                                formattedValue += '<br>';
                            });
                        }
                        return formattedValue;
                        }
                },
                {
                    'targets': [2] ,
                    'mRender': function (data, type, row) {
                        let formattedValue = '';
                        if (row.hasOwnProperty('ipScopes')) {
                            row.ipScopes.map(function(item, index) {
                                formattedValue += item.prefixLength + '<br>';
                            });
                        }
                        return formattedValue;
                        }
                },
                {
                    'targets': [3] ,
                    'mRender': function (data, type, row) {
                        let formattedValue = '';
                        if (row.hasOwnProperty('ipScopes')) {
                            row.ipScopes.map(function(item, index) {
                                formattedValue += getRangeValues(item.networkIpRanges) + '<br>';
                            });
                        }
                        return formattedValue;
                    }
                }
        ],
        'autoWidth': true,
        'oLanguage': {
            'sSearch': '',
            'sEmptyTable': '',
            'sInfoEmpty': ''
        },
        'scrollY': '100vh',
        'scrollCollapse': true,
        'paging': false,
        'bFilter': true,
        'bDestroy': true,
        'bUseRendered': false,
        'order': [[0, 'desc']],
        'rowCallback': function (row, data) {
        }
    };
}
function getRangeValues(ipRanges) {
    let range = '';
    ipRanges.map(function(item, index) {
        if (index !== 0) {
            range += '<br>';
        }
        range += item.startAddress + ' - ' + item.endAddress;
    });
    return range;
}

export function getAddressGroupListingDatatableConfig() {
    return {
        dom: 'Bfrtip',
        columns: [
            { 'title': 'Primary Address', 'data': 'primaryAddress', 'width': '100px' },
            { 'title': 'Secondary Addresses', 'data': 'secondaryAddresses', 'width': '200px' },
            { 'title': 'Prefix Length', 'data': 'subnetPrefixLength', 'width': '100px'}
        ],
        columnDefs: [
            {
                'targets': [1] ,
                'mRender': function (data, type, row) {
                    if (data) {
                        return '<div style="width:200px;word-break: break-word; white-space: normal;">' + data + '</div>';
                    }
                    return '';
                }
            }
        ],
        'autoWidth': false,
        'oLanguage': {
            'sSearch': '',
            'sEmptyTable': '',
            'sInfoEmpty': ''
        },
        'scrollY': '100vh',
        'scrollCollapse': true,
        'paging': false,
        'bFilter': true,
        'bDestroy': true,
        'bUseRendered': false,
        'order': [[0, 'desc']],
        'rowCallback': function (row, data) {
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/dialogs/add-edit-interface-dialog.dt.config.ts